'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.handleTjLink = void 0;
var getParam = function (e, t) {
        var n = t.replace('?', '').split('&'), a = '';
        if (n)
            for (var r = 0, c = n.length; r < c; r++) {
                var o = n[r].split('=');
                e === o[0] && (a = o[1]);
            }
        return a;
    }, getATag = function e(t) {
        return t ? 'A' !== t.tagName ? e(t.parentElement) : t : null;
    }, handleTjLink = function (e) {
        if (getATag(e.target)) {
            for (var t = location.search, n = location.href, a = '', r = !1, c = ["http://dol.deliver.ifeng.com/"], o = 0, i = c.length; o < i; o++)
                -1 < n.indexOf(c[o]) && (r = !0);
            if (t && getParam('ch', t) && !r) {
                var l = getParam('ch', t);
                a = -1 < n.indexOf('?') ? getParam('ch', n) ? n.replace('ch='.concat(getParam('ch', n)), 'ch='.concat(l)) : ''.concat(n, '&ch=').concat(l) : ''.concat(n, '?ch=').concat(l), window.location.href = a, event && event.preventDefault ? event.preventDefault() : window.event.returnValue = !1;
            }
        }
    };
exports.handleTjLink = handleTjLink;